import { useCallback } from 'react'

import axios from 'axios'

type BrasilReturnAddressReturn = {
  cep?: string
  state?: string
  city?: string
  neighborhood?: string
  street?: string
}

export function useBrasilAPI() {
  const getBrasilAPIAddressByCEP = useCallback(async (cep: string): Promise<any> => {
    try {
      const response: { data: BrasilReturnAddressReturn } = await axios.get(
        `https://brasilapi.com.br/api/cep/v1/${cep}`,
        { timeout: 60000 } // 1 Minuto
      )

      return response.data
    } catch (error: any) {
      if (error?.response?.data) {
        return error?.response?.data
      }

      return { message: 'Tempo limite excedido, não foi possível buscar este CEP' }
    }
  }, [])

  return {
    getBrasilAPIAddressByCEP,
  }
}
